import * as React from 'react'
import { FunctionComponent } from 'react'

const Users: FunctionComponent = () => {
    return <>Users</>
}

export default Users
